import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

class SelectValidator extends ValidatorComponent {

    renderValidatorComponent() {
        const { errorMessages, validators, label, tooltip, isRemoveFg, hideLabel, requiredError, isRequired, className, infotext, withRequiredValidator, validatorListener, ...rest } = this.props;
        const { isValid } = this.state;
        return (
            <div className={(isRemoveFg ? "inline-input" : "form-group") + (isValid ? "" : " has-error")}>
                {hideLabel ? null : (<label>{label} {tooltip} {isRequired ? (<span className="text-danger">*</span>) : ''}</label>)}
                <select className={(className ? className : "") + " form-control"}
                    {...rest}
                    ref={(r) => { this.input = r; }}>
                </select>
                {infotext && !this.errorText() ? <small className="text-muted">{infotext}</small> : ""}
                {this.errorText()}
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <span className="help-block">
                {this.getErrorMessage()}
            </span>
        );
    }
}

export default SelectValidator;


// WEBPACK FOOTER //
// ./src/components/shared/selectvalidator.js